<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输入系统专业名"
                v-model="queryObj.keyWord"
                size="small"
                class="query"
                style="float: left"
                clearable
                @change="()=>{this.queryObj.pageNum = 1;init()}">
        <i slot="suffix"
           class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary"
                 icon="el-icon-font el-icon-web__tianjia"
                 size="mini"
                 style="margin-right:6px"
                 @click="add_init">新增</el-button>
      <es-delete @del="del()"
                 type="button"></es-delete>
    </div>
    <el-table :data="pageData.list"
              ref="systemTable"
              border
              stripe
              size="mini"
              height="calc(100vh - 180px)"
              v-loading="loading">
      <el-table-column type="selection"
                       width="40"
                       align="center">
      </el-table-column>
      <el-table-column type="index"
                       label="序号"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column prop="name"
                       label="系统专业">
      </el-table-column>
      <el-table-column label="操作"
                       width="80"
                       align="center">
        <template slot-scope="scope">
          <el-link :underline="false"
                   title="编辑"
                   @click="edit_init(scope.row)"
                   type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)"
                     :key="scope.row.id"
                     type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData"
                     @change="(cpage)=>{this.queryObj.pageNum=cpage;this.loadSystemList()}">
      </es-pagination>
    </div>
    <!--编辑系统专业-->
    <el-dialog :visible.sync="editVisible"
               @closed="()=>this.$refs['systemForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑系统专业
      </span>
      <el-form :model="systemInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="systemForm">
        <el-form-item prop="name"
                      label="系统专业">
          <el-input v-model="systemInfo.name"
                    placeholder="请输入系统专业"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitSystem()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'sys',
  props: ["funcs"],
  data () {
    return {
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      systemInfo: {},//系统信息
      rules: {//验证条件
        name: [
          { required: true, message: '请输入系统专业', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadSystemList()
    },
    //从后台查询系统专业列表
    loadSystemList () {
      this.loading = true
      this.$ajax.get('/base/system/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    //初始化添加系统专业
    add_init () {
      this.editVisible = true
      this.systemInfo = {}
    },
    //初始化系统专业
    edit_init (row) {
      this.editVisible = true
      this.systemInfo = JSON.parse(JSON.stringify(row))
    },
    //保存系统专业
    submitSystem () {
      this.$refs["systemForm"].validate(valid => {
        if (valid) {
          let url = "/base/system/add";
          if (this.systemInfo.id != null) {
            url = "/base/system/edit";
          }
          this.saving = true
          this.$ajax.post(url, this.systemInfo).then(msg => {
            this.saving = false
            this.loadSystemList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除系统专业
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["systemTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/system/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadSystemList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
</style>
